module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kj-Lc.39829afd.png";